export default {
  maxWidth: 1200,
  headerHeight: 60,
  siderWidth: 226,
  mobileButtonHeight: 60
}
